import { parseURL, getURLParameterByName } from './url';
import getReferrer from './referrer';

const UTM_SOURCE = 'utm_source';
const UTM_MEDIUM = 'utm_medium';
const UTM_CAMPAIGN = 'utm_campaign';
const NONE = 'none';

const DIMENSIONS_MAPPER = {
  campaign: UTM_CAMPAIGN,
  medium: UTM_MEDIUM,
  source: UTM_SOURCE
};

export const ORGANIC = 'organic';
export const DIRECT = 'direct';
export const DEFAULT_REFERRER = 'Referrer';
export const IGNORE_REFERRERS = ['loggi.com'];
export const KNOWN_REFERRERS = {
  google: 'google.com',
  bing: 'bing.com',
  yahoo: 'yahoo.com'
};

export function getSourceFromReferrer(url) {
  const shouldIgnore =
    !url || IGNORE_REFERRERS.some(hostname => url.match(hostname));
  if (shouldIgnore) {
    return null;
  }

  const knownReferrer = Object.keys(KNOWN_REFERRERS).find(key =>
    url.match(KNOWN_REFERRERS[key])
  );
  return knownReferrer || DEFAULT_REFERRER;
}

export default function getTrafficSourceProps() {
  const hasUtmProps = Object.keys(DIMENSIONS_MAPPER).some(key =>
    getURLParameterByName(DIMENSIONS_MAPPER[key])
  );

  if (hasUtmProps) {
    // We don't want to change utm parameters when they're already
    // defined in URL
    return {};
  }

  // Try to find non-utm-prefixed URL parameters
  let props = Object.keys(DIMENSIONS_MAPPER).reduce((obj, key) => {
    const paramValue = getURLParameterByName(key);
    if (paramValue) {
      const paramKey = DIMENSIONS_MAPPER[key];
      obj[paramKey] = paramValue;
    }
    return obj;
  }, {});

  // If we couldn't find parameters on URL, we'll look for referrer
  const referrer = getReferrer();
  if (Object.keys(props).length === 0) {
    //We don't have any traffic source parameters, we'll determine whether
    //we have a direct source or organic
    props = {
      [UTM_SOURCE]: DIRECT,
      [UTM_MEDIUM]: NONE,
      [UTM_CAMPAIGN]: NONE
    };

    if (referrer !== null) {
      const url = parseURL(referrer);
      if (url !== null) {
        const source = getSourceFromReferrer(url.hostname);

        if (source !== null) {
          props = {
            [UTM_SOURCE]: source,
            [UTM_MEDIUM]: ORGANIC,
            [UTM_CAMPAIGN]: NONE
          };
        }
      }
    }
  }

  return props;
}
